import { alignMultisite4nkWebLineHostToPageLine } from "le-coffre-resources/dist/browserPublicHostPatterns.js";
import {
	rewriteBackApiHostWhenApiSubdomainMirrorsPage,
	rewriteLegacyLecoffreIoFrontUrlOnV2NotaryPage,
} from "@Front/Config/configRuntimeUrlHelpers";

export class FrontendVariables {
	private static _instance: FrontendVariables | null = null;

	public BACK_API_PROTOCOL!: string;

	public BACK_API_HOST!: string;

	public BACK_API_ROOT_URL!: string;

	public BACK_API_VERSION!: string;

	public FRONT_APP_HOST!: string;

	public IDNOT_BASE_URL!: string;

	public IDNOT_AUTHORIZE_ENDPOINT!: string;

	public IDNOT_CLIENT_ID!: string;

	public KEY_DATA!: string;

	public SPLASH_ID!: string;

	public SPLASH_MESSAGE!: string;

	public SPLASH_MAX_DISPLAYS!: string;

	private assignBackApiEnv(): void {
		this.BACK_API_PROTOCOL = process.env["NEXT_PUBLIC_BACK_API_PROTOCOL"] ?? "";
		this.BACK_API_HOST = process.env["NEXT_PUBLIC_BACK_API_HOST"] ?? "";
		this.BACK_API_ROOT_URL = process.env["NEXT_PUBLIC_BACK_API_ROOT_URL"] ?? "";
		this.BACK_API_VERSION = process.env["NEXT_PUBLIC_BACK_API_VERSION"] ?? "";
	}

	private assignFrontAndIdNotEnv(): void {
		this.FRONT_APP_HOST = process.env["NEXT_PUBLIC_FRONT_APP_HOST"] ?? "";
		this.IDNOT_BASE_URL = process.env["NEXT_PUBLIC_IDNOT_BASE_URL"] ?? "";
		this.IDNOT_AUTHORIZE_ENDPOINT = process.env["NEXT_PUBLIC_IDNOT_AUTHORIZE_ENDPOINT"] ?? "";
		this.IDNOT_CLIENT_ID = process.env["NEXT_PUBLIC_IDNOT_CLIENT_ID"] ?? "";
	}

	private assignKeyDataAndSplashEnv(): void {
		this.KEY_DATA = process.env["KEY_DATA"] ?? "";
		this.SPLASH_ID = process.env["NEXT_PUBLIC_SPLASH_ID"] ?? "splash_v1";
		this.SPLASH_MESSAGE = process.env["NEXT_PUBLIC_SPLASH_MESSAGE"] ?? "";
		this.SPLASH_MAX_DISPLAYS = process.env["NEXT_PUBLIC_SPLASH_MAX_DISPLAYS"] ?? "10";
	}

	private applyBrowserHostRewritesWhenClient(): void {
		if (typeof window === "undefined") {
			return;
		}
		const wh = window.location.host;
		this.BACK_API_HOST = rewriteBackApiHostWhenApiSubdomainMirrorsPage(wh, this.BACK_API_HOST);
		this.FRONT_APP_HOST = rewriteLegacyLecoffreIoFrontUrlOnV2NotaryPage(this.FRONT_APP_HOST);
		this.FRONT_APP_HOST = alignMultisite4nkWebLineHostToPageLine(wh, this.FRONT_APP_HOST);
	}

	private constructor() {
		this.assignBackApiEnv();
		this.assignFrontAndIdNotEnv();
		this.applyBrowserHostRewritesWhenClient();
		this.assignKeyDataAndSplashEnv();
	}

	public static get instance(): FrontendVariables {
		if (!FrontendVariables._instance) {
			FrontendVariables._instance = new FrontendVariables();
		}
		return FrontendVariables._instance;
	}

	public static getInstance(): FrontendVariables {
		return FrontendVariables.instance;
	}
}
